var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"post-editor"},[_c('px-input',{staticClass:"xl",attrs:{"placeholder":"Tag title"},model:{value:(_vm.postData.title),callback:function ($$v) {_vm.$set(_vm.postData, "title", $$v)},expression:"postData.title"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }